import React from "react";
import {
  Navbar,
  Typography,
  Button,
  Collapse,
  IconButton,
} from "@material-tailwind/react";
import { Link } from "react-router";

const Nav = () => {
  const [openNav, setOpenNav] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false),
    );
  }, []);

  const navList = (
    <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">

      {[
        { path: "/", label: "Home" },
        { path: "/Categories", label: "Categories" },
        { path: "/Treatments", label: "Treatments" },
        // { path: "/Packages", label: "Packages" },
        // { path: "/Loyalty", label: "Loyalty Cards" },
        { path: "/About-us", label: "About us" },
        { path: "/Gallery", label: "Gallery" },
        // { path: "/Contact-us", label: "Contact us" },
      ].map((item) => (
        <li key={item.path}>
          <Link
            to={item.path}
            className="navItem hover:text-customBeige-50"
            onClick={() => setOpenNav(false)}
          >
            <Typography as="span" variant="small">
              {item.label}
            </Typography>
          </Link>
        </li>
      ))}

    </ul>
  );

  return (

    <nav className="fixed top-0 z-50 h-max w-full rounded-none rounded-b-lg px-4 shadow-none blur-none py-2 lg:px-8 lg:py-4 border-none  bg-transparent text-white header mobileHeader">
      <div className="flex items-center justify-between ">
        {/* <div className="md:hidden"></div> */}
        <Link to={"/Home"}>
          <Typography
            className="mr-4 cursor-pointer font-sans py-1.5 lg:text-xl"
          >
            Ceylon Hospital Wellness
          </Typography>
        </Link>
        {/* End Navbar Title */}
        {/* Start Navbar */}
        <div className="flex items-center gap-4">
          <div className="mr-4 hidden lg:block">{navList}</div>
          {/* Start login, sign in buttons */}
          {/* <div className="flex items-center gap-x-1">
            <Button
              variant="text"
              size="sm"
              className="hidden lg:inline-block"
            >
              <span>Log In</span>
            </Button>
            <Button
              variant="gradient"
              size="sm"
              className="hidden lg:inline-block"
            >
              <span>Sign in</span>
            </Button>
          </div> */}
          {/* End login, sign in buttons */}
          <IconButton
            variant="text"
            className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
            ripple={false}
            onClick={() => setOpenNav(!openNav)}
          >
            {openNav ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                className="h-6 w-6"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </IconButton>
        </div>
        {/* End Navbar */}
        <div className="hidden lg:inline-block">
          <div className="flex items-center gap-x-1">
            <Link to={'/BookNow'}>
              <Button
                variant="text"
                size="md"
                className="rounded-sm text-white hover:text-black bg-gradient-to-r from-customBeige-45 to-customBeige-45 
              hover:from-customBeige-55 hover:to-customBeige-55
              transition hover:duration-500  ease-in-out"
              >
                <span>Book Now</span>
              </Button>
            </Link>
          </div>
        </div>
      </div>
      {/* Start Mobile navbar */}
      <Collapse className="backdrop-blur-sm bg-black/70" open={openNav}>
        <div className="p-6 pt-0">
          {navList}
          <div className="flex items-center gap-x-1">
            <Link to={'/BookNow'}>
              <Button variant="gradient"
                size="md"
                className="rounded-sm text-white hover:text-black bg-gradient-to-r from-customBeige-45 to-customBeige-45 
              hover:from-customBeige-55 hover:to-customBeige-55
              transition hover:duration-500  ease-in-out"
                onClick={() => setOpenNav(false)}
              >
                <span>Book Now</span>
              </Button>
            </Link>
          </div>
        </div>
      </Collapse>
      {/* End Mobile navbar */}
    </nav>
  );
}

export default Nav
